import React, {useEffect, useState} from "react";
import {InputAdornment, MenuItem, popoverClasses, Select} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Language} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";

export const LangSwitcher = () => {
    const {t, i18n} = useTranslation()

    const navigate = useNavigate()
    const [language, setLanguage] = useState('en')
    const handleChangeLanguage = (e) => {
        i18n.changeLanguage(e.target.value)
            .then(() => {
                navigate(e.target.value === 'en' ? '/' + e.target.value : '/', {replace: true})
            })
    }

    useEffect(() =>{
        setLanguage(['it', 'en'].includes(i18n.language.split('-')[0]) ? i18n.language.split('-')[0] : 'en')
    },[i18n.language])

    return (
        <Select variant='standard'
                sx={{
                    color:'white',
                    opacity: 0.7,
                }}
                startAdornment={<InputAdornment position="start"><Language /></InputAdornment>}
                value={language}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            borderRadius: 4
                        },
                    },
                }}
                onChange={handleChangeLanguage}>
            <MenuItem value={'it'}>ITA</MenuItem>
            <MenuItem value={'en'}>ENG</MenuItem>
        </Select>
    )
}
